/** Libellés UI — rétention fichiers dossiers archivés (hors `folderMessages` pour limites max-lines). */
import { COMMON_UI_I18N_FOLDER_STATUS_MESSAGES } from "./commonUiI18nFolderStatusMessages";

export const COMMON_UI_I18N_PART1_SLICE_D = {
	folderStatusMessages: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES,
	folderBlobRetentionUi: {
		archivedBlobRetentionDateLabel: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.retention.dateLabel,
		archivedBlobRetentionDatePast: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.retention.datePastMessage,
		archivedBlobRetentionAlertTitle: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.retention.alertTitle,
		archivedBlobRetentionAlertBody: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.retention.alertBody,
	},
} as const;
